import React from 'react'
// components
import { Tooltip, OverlayTrigger, Row, Col, Card, Button, Tabs, Tab } from 'react-bootstrap'

// definitions
import * as AppDefinitions from '../../../App.d'
import { HistoryView, InvoiceRetryBody, EventRetryBody } from '../../../screens/subsync/subsync'

// utilities
import { RefreshCw } from 'react-feather'

// helper functions
import { InvoiceHistory } from './invoices'
import { PayoutHistory } from './payouts'
import { useLocation } from 'react-router-dom'
import { PaymentHistory } from './payments'

interface OverviewComponentFrameProps {
	show: boolean
	appState: AppDefinitions.AppState
	stripeFeesBillsEnabled: boolean
	creditNotesEnabled: boolean
	historyView: HistoryView
	updateHistoryView: (historyView: HistoryView) => void
	refreshInvoiceData: () => void
	refreshPayoutData: () => void
	refreshPaymentData: () => void
	retryFailedInvoiceTransaction: (body: InvoiceRetryBody) => void
	retryFailedEvent: (body: EventRetryBody) => void
}

type TabKey = 'invoices' | 'payouts' | 'payments'

const getTabKeyFromHash = (hash: string): TabKey => {
	return ['invoices', 'payouts', 'payments'].includes(hash) ? (hash as TabKey) : 'invoices'
}

const OverviewComponent = (props: OverviewComponentFrameProps) => {
	const location = useLocation()
	const [tabKey, setTabKey] = React.useState<TabKey>(getTabKeyFromHash(location.hash.split('/')[1]))

	const updateTabAndHash = (key: TabKey) => {
		window.location.hash = `overview/${key}`
		setTabKey(key)
	}

	if (!props.show) {
		return null
	}

	return (
		<Card className="subsync-card mt-4 mb-2">
			<Row>
				<Col style={{ display: 'flex' }}>
					<div className="settings-label">Event History</div>
					<Col sm="auto" style={{ margin: '13px 0 0 -20px' }}>
						<OverlayTrigger placement="auto" overlay={<Tooltip id={`tooltip-remove-connection`}>Refresh</Tooltip>}>
							<Button
								type="submit"
								style={{ border: '0px' }}
								onClick={() =>
									tabKey === 'invoices'
										? props.refreshInvoiceData()
										: tabKey === 'payments'
										? props.refreshPaymentData()
										: props.refreshPayoutData()
								}
							>
								<RefreshCw />
							</Button>
						</OverlayTrigger>
					</Col>
				</Col>
			</Row>
			<Tabs className="mb-3 mt-2 mx-2" activeKey={tabKey} onSelect={(k) => updateTabAndHash(k as TabKey)}>
				<Tab eventKey="invoices" title="Invoices">
					<InvoiceHistory {...props} />
				</Tab>
				<Tab eventKey="payments" title="Payments">
					<PaymentHistory {...props} />
				</Tab>
				<Tab eventKey="payouts" title="Payouts (BETA)">
					<PayoutHistory {...props} />
				</Tab>
			</Tabs>
		</Card>
	)
}

export default OverviewComponent
export type { OverviewComponentFrameProps }
